<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 9L9 27"
      stroke="#363C56"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 9L27 27"
      stroke="#363C56"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconClose extends Vue {}
</script>
